(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bo-hero-rotation')) {
  customElements.define('bo-hero-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const image = this.querySelector('.bo-hero__slide');
      const data = this.querySelector('script[type="application/json"]');
      if (!image || !data) return;
      let urls = [];
      try { urls = JSON.parse(data.textContent).filter((url) => typeof url === 'string' && url); } catch { return; }
      if (!urls.length) return;
      const storageKey = 'bo-homepage-hero-image-v1';
      let previousImage = '';
      try { previousImage = window.localStorage.getItem(storageKey) || ''; } catch {}
      const choices = urls.filter((url) => url !== previousImage);
      const selectedImage = choices[Math.floor(Math.random() * choices.length)] || urls[0];
      image.src = selectedImage;
      this.dataset.initialized = 'true';
      try { window.localStorage.setItem(storageKey, selectedImage); } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-ritual-grid"] && !Shopify.designMode) return;
  try {
    
  const homepageMeltImage = document.querySelector('[data-homepage-melt-images]');
  if (homepageMeltImage) {
    const options = homepageMeltImage.dataset.homepageMeltImages.split('|').filter(Boolean);
    const storageKey = 'bo-homepage-melt-image-v1';
    let previousImage = '';
    try {
      previousImage = window.localStorage.getItem(storageKey) || '';
    } catch (error) {}
    const choices = options.filter((imageUrl) => imageUrl !== previousImage);
    const selectedImage = choices[Math.floor(Math.random() * choices.length)] || options[0];
    homepageMeltImage.src = selectedImage;
    try {
      window.localStorage.setItem(storageKey, selectedImage);
    } catch (error) {}
  }
  function initializeSoapRotation(root) {
    root.querySelectorAll('[data-homepage-soap-images]').forEach((image) => {
      if (image.dataset.rotationReady) return;
      const images = image.dataset.homepageSoapImages.split('|').filter(Boolean);
      if (!images.length) return;
      const storageKey = 'bo-homepage-soap-image-v1';
      let previousImage = '';
      try { previousImage = window.sessionStorage.getItem(storageKey) || ''; } catch {}
      const choices = images.filter((url) => url !== previousImage);
      const selectedImage = choices[Math.floor(Math.random() * choices.length)] || images[0];
      image.src = selectedImage;
      image.dataset.rotationReady = 'true';
      try { window.sessionStorage.setItem(storageKey, selectedImage); } catch {}
    });
  }
  initializeSoapRotation(document);
  document.addEventListener('shopify:section:load', (event) => initializeSoapRotation(event.target));

  } catch(e) { console.error(e); }
})();
})();
